<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Senarai Penyesuaian">
            <w-card bg-color="" class="">
                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Nama Fail :</h5>
                        <div class="fw-normal my1 fs-1">{{form.nama_fail}}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Bil. Rekod:</h5>
                        <div class="fw-normal my1 fs-1">{{form.bil_rekod}}</div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Tarikh Fail:</h5>
                        <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.tarikh_fail)}}</div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Bil. Rekond Sepadan:</h5>
                        <div class="fw-normal my1 fs-1">{{ form.bil_sepadan }}</div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Tarikh Proses:</h5>
                        <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.tarikh_proses)}}</div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Bil. Rekod Ralat:</h5>
                        <div class="fw-normal my1 fs-1">{{ form.bil_ralat }}</div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                       <!--  <h5 class="fw-semibold m0">Diproses Oleh:</h5>
                        <div class="fw-normal my1 fs-1">{{form.user_id}}</div> -->
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Amaun Fail(RM):</h5>
                        <div class="fw-normal my1 fs-1">
                        {{$zutil.currency(form.amaun_fail)}}
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Status:</h5>
                        <div class="fw-normal my1 fs-1">{{form.status}}</div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Amaun Resit(RM):</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_resit) }}</div>
                    </div>
                </w-flex>
                <w-flex class="mt3" wrap align-center justify-end>
                  <w-button
                      class="my1"
                      bg-color="primary"
                      dark
                      @click="prosesSemula()"
                      >Proses Semula</w-button
                  >
              </w-flex>
            </w-card>

            <w-tabs :items="tabs" :no-slider="false" active-class="primary">
              <template #item-content.1>
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                  <table class="table-dashboard" width="100%">
                      <thead>
                          <tr class="center">
                              <td>Bil</td>
                              <td>Jenis Pembayaran</td>
                              <td>Id. Pembayaran</td>
                              <td>No.Rujukan</td>
                              <td>Nama</td>
                              <td>Tarikh Bayar</td>
                              <td>No. Resit</td>
                              <td>Cara Bayar</td>
                              <td>Amaun(RM)</td>
                              <td>Status</td>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(dt, index) in form.resitt">
                            <td>{{ index + 1 }}</td>
                            <td>{{dt.sumber_keterangan}}</td>
                            <td>{{dt.payment}}</td>
                            <td>{{dt.no_rujukan}}</td>
                            <td>{{dt.nama}}</td>
                            <td>{{$zutil.dateformat(dt.tarikh_bayar)}}</td>
                            <td>{{dt.no_resit}}</td>
                            <td>{{dt.cara_terimaan}}</td>
                            <td>{{$zutil.currency(dt.amaun)}}</td>
                            <td>{{dt.status == 1 ? 'Sepadan' : 'Tidak Sepadan'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
              </template>

              <template #item-content.2>
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                  <table class="table-dashboard" width="100%">
                      <thead>
                          <tr class="center">
                              <td>Bil</td>
                              <td>Kedah</td>
                              <td>Rujukan</td>
                              <td>Pembayar</td>
                              <td>Jumlah</td>
                              <td>Status</td>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(dt, index) in form.data_excel">
                            <td>{{dt[0]}}</td>
                            <td>{{dt[1]}}</td>
                            <td>{{dt[2]}}</td>
                            <td>{{dt[3]}}</td>
                            <td>{{dt[5]}}</td>
                            <td>{{dt[6]}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
              </template>

              <template #item-content.3>
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                  <table class="table-dashboard" width="100%">
                      <thead>
                          <tr class="center">
                            <td>Bil</td>
                            <td>Jenis Pembayaran</td>
                            <td>Jabatan</td>
                            <td>Nama Fail</td>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(dt, index) in form.fail">
                            <td>{{index + 1}}</td>
                            <td>{{dt.sumber}}</td>
                            <td>{{dt.jabatan_id}}</td>
                            <td><template v-if="dt.nama_fail">
                                  <a :href="dt.link_fail">{{dt.nama_fail}}</a>
                                </template>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
              </template>
            </w-tabs>
              <w-flex class="mt3" wrap align-center justify-end>
                  <w-button
                      class="my1"
                      bg-color="warning"
                      dark
                      @click="back()"
                      >Kembali</w-button
                  >
              </w-flex>
        </z-page>
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
      resourceurl: this.service_ibayaq+'penyesuaian',
      reload: true,
      
      tabs: [
          { title: "Resit", content: "" },
          { title: "Penyata", content: "" },
          { title: "Senarai Fail", content: "" },
      ],
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Penyesuaian', route: '/Penyesuaian/Recon' },
        { label: 'Papar', route: '/penyesuaian/'+this.id },
      ],
    }
  },
  methods: {
    back() {
      window.history.back();
    },
    prosesSemula(){
      this.$zcomm.get(this.service_ibayaq+'penyesuaian/proses_semula/'+this.form.id).then(res => {
                // this.show(res);
                this.$inertia.visit(this.$page.url)
              });
    }
  
  },
  watch: {

  },
  mounted() {
    
      
  },
    
}
</script>